(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-strip"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    document.querySelectorAll('[data-section-type="buy-strip"]').forEach((root)=>{
      root.querySelectorAll('[data-cta]').forEach((el)=>{
        el.addEventListener('click',()=>{
          if(window.Shopify && Shopify.analytics && Shopify.analytics.publish){
            Shopify.analytics.publish('buystrip_cta_click',{sectionId:root.dataset.sectionId,kind:el.getAttribute('data-cta')});
          }
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chapter-nav"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    document.querySelectorAll('[data-section-type="chapter-nav"]').forEach((root)=>{
      const sticky = String(root.getAttribute('data-sticky')) !== 'false';
      const offset = parseInt(root.getAttribute('data-offset')||'0',10);
      if(sticky){
        root.classList.add('is-sticky');
        if(offset){ root.style.top = offset + 'px'; }
      }

      const links = Array.from(root.querySelectorAll('.cn__link'));
      if(!('IntersectionObserver' in window) || !links.length) return;
      const map = new Map();
      links.forEach(l=>{
        const id = l.getAttribute('data-target-id');
        const t = id && document.getElementById(id);
        if(t){ map.set(t, l); }
      });

      const setCurrent = (el)=>{
        links.forEach(a=>a.removeAttribute('aria-current'));
        if(el) el.setAttribute('aria-current','true');
      };

      const io = new IntersectionObserver((entries)=>{
        let best = null; let max = 0;
        entries.forEach(e=>{
          if(!map.has(e.target)) return;
          const v = e.intersectionRatio;
          if(v>max){ max=v; best=e.target; }
        });
        if(best) setCurrent(map.get(best));
      }, { threshold:[0,0.25,0.5,0.75,1], rootMargin:'-20% 0px -60% 0px' });

      map.forEach((_, target)=> io.observe(target));
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-stage"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const reduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-section-type="cinematic-stage"]').forEach((root)=>{
      const overlay = root.querySelector('[data-cs-overlay] .cs__overlay-track');
      const stepsWrap = root.querySelector('[data-cs-steps]');
      if(!overlay || !stepsWrap) return;
      const steps = Array.from(stepsWrap.querySelectorAll('.cs__step'));
      if(!steps.length) return;

      const go = (i)=>{
        const idx = Math.max(0, Math.min(i, steps.length-1));
        overlay.style.transform = 'translateX(' + (-100 * idx) + '%)';
      };

      if('IntersectionObserver' in window){
        const io = new IntersectionObserver((entries)=>{
          let best = null; let max = 0;
          entries.forEach((e)=>{
            if(e.intersectionRatio > max){ max = e.intersectionRatio; best = e.target; }
          });
          if(best){ const i = steps.indexOf(best); if(i>=0) go(i); }
        }, { threshold:[0,0.25,0.5,0.75,1], rootMargin:'-20% 0px -60% 0px' });
        steps.forEach(s=>io.observe(s));
      }

      // Initialize
      go(0);
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inline-gallery"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    document.querySelectorAll('[data-section-type="inline-gallery"]').forEach((root)=>{
      const track = root.querySelector('.ig__track');
      if(!track) return;
      const slides = Array.from(track.querySelectorAll('.ig__slide'));
      const prev = root.querySelector('[data-ig-prev]');
      const next = root.querySelector('[data-ig-next]');
      const scrollToIndex = (i)=>{
        const idx = Math.max(0, Math.min(i, slides.length-1));
        const el = slides[idx];
        if(el) el.scrollIntoView({behavior:'smooth', inline:'center'});
      };
      let current = 0;
      if('IntersectionObserver' in window){
        const io = new IntersectionObserver((ents)=>{
          let best=null,max=0;ents.forEach(e=>{if(e.intersectionRatio>max){max=e.intersectionRatio;best=e.target;}});
          if(best){ current = slides.indexOf(best); }
        }, {root:track, threshold:[0,0.5,1]});
        slides.forEach(s=>io.observe(s));
      }
      if(prev) prev.addEventListener('click',()=>scrollToIndex(current-1));
      if(next) next.addEventListener('click',()=>scrollToIndex(current+1));
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metrics-grid"] && !Shopify.designMode) return;
  try {
    
  (()=>{})();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-pro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReduced = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-section-type="product-details-Pro"]').forEach((root) => {
      // Video: autoplay/pause in view
      const video = root.querySelector('video[data-replay-on-scroll]');
      if (video) {
        const autoplayEnabled = String(video.getAttribute('data-autoplay')) !== 'false';
        const loopEnabled = String(video.getAttribute('data-loop')) !== 'false';
        try { video.loop = !!loopEnabled; } catch (e) {}

        if (prefersReduced()) {
          video.removeAttribute('autoplay');
          try { video.pause(); } catch (e) {}
        } else if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                if (autoplayEnabled) {
                  if (loopEnabled || !video.ended) {
                    const p = video.play();
                    if (p && typeof p.catch === 'function') p.catch(() => {});
                  }
                }
              } else {
                try { video.pause(); video.currentTime = 0; } catch (e) {}
              }
            });
          }, { threshold: [0, 0.5, 1] });
          io.observe(video);
        } else if (autoplayEnabled) {
          const p2 = video.play();
          if (p2 && typeof p2.catch === 'function') p2.catch(() => {});
        }
      }

      // Overlay rotator (progressive enhancement)
      const overlay = root.querySelector('[data-features-rotator]');
      if (overlay) {
        const track = overlay.querySelector('.pd3__overlay-track');
        const items = overlay.querySelectorAll('.pd3__overlay-item');
        if (!track || !items.length) return;

        const auto = overlay.getAttribute('data-auto') !== 'false' && !prefersReduced();
        const interval = parseInt(overlay.getAttribute('data-interval') || '4000', 10);
        let index = 0;
        let timer = null;

        const go = (i) => {
          index = (i + items.length) % items.length;
          track.style.transform = 'translateX(' + (-100 * index) + '%)';
        };
        const start = () => { if (auto) { stop(); timer = setInterval(() => go(index + 1), interval); } };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

        const prev = overlay.querySelector('[data-ov-prev]');
        const next = overlay.querySelector('[data-ov-next]');
        if (prev) prev.addEventListener('click', () => { stop(); go(index - 1); });
        if (next) next.addEventListener('click', () => { stop(); go(index + 1); });

        overlay.addEventListener('mouseenter', stop);
        overlay.addEventListener('mouseleave', start);
        overlay.addEventListener('focusin', stop);
        overlay.addEventListener('focusout', start);

        if ('IntersectionObserver' in window) {
          const io2 = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) start(); else stop(); });
          }, { threshold: [0, 0.2, 0.6, 1] });
          io2.observe(overlay);
        } else {
          start();
        }

        go(0);
      }
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReduced = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-section-type="product-details-v2"]').forEach((root) => {
      // Video: autoplay/pause in view
      const video = root.querySelector('video[data-replay-on-scroll]');
      if (video) {
        const autoplayEnabled = String(video.getAttribute('data-autoplay')) !== 'false';
        const loopEnabled = String(video.getAttribute('data-loop')) !== 'false';
        try { video.loop = !!loopEnabled; } catch (e) {}

        if (prefersReduced()) {
          video.removeAttribute('autoplay');
          try { video.pause(); } catch (e) {}
        } else if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                if (autoplayEnabled) {
                  if (loopEnabled || !video.ended) {
                    const p = video.play();
                    if (p && typeof p.catch === 'function') p.catch(() => {});
                  }
                }
              } else {
                try { video.pause(); video.currentTime = 0; } catch (e) {}
              }
            });
          }, { threshold: [0, 0.5, 1] });
          io.observe(video);
        } else if (autoplayEnabled) {
          const p2 = video.play();
          if (p2 && typeof p2.catch === 'function') p2.catch(() => {});
        }
      }

      // Overlay rotator (progressive enhancement)
      const overlay = root.querySelector('[data-features-rotator]');
      if (overlay) {
        const track = overlay.querySelector('.pd3__overlay-track');
        const items = overlay.querySelectorAll('.pd3__overlay-item');
        if (!track || !items.length) return;

        const auto = overlay.getAttribute('data-auto') !== 'false' && !prefersReduced();
        const interval = parseInt(overlay.getAttribute('data-interval') || '4000', 10);
        let index = 0;
        let timer = null;

        const go = (i) => {
          index = (i + items.length) % items.length;
          track.style.transform = 'translateX(' + (-100 * index) + '%)';
        };
        const start = () => { if (auto) { stop(); timer = setInterval(() => go(index + 1), interval); } };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

        const prev = overlay.querySelector('[data-ov-prev]');
        const next = overlay.querySelector('[data-ov-next]');
        if (prev) prev.addEventListener('click', () => { stop(); go(index - 1); });
        if (next) next.addEventListener('click', () => { stop(); go(index + 1); });

        overlay.addEventListener('mouseenter', stop);
        overlay.addEventListener('mouseleave', start);
        overlay.addEventListener('focusin', stop);
        overlay.addEventListener('focusout', start);

        if ('IntersectionObserver' in window) {
          const io2 = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) start(); else stop(); });
          }, { threshold: [0, 0.2, 0.6, 1] });
          io2.observe(overlay);
        } else {
          start();
        }

        go(0);
      }
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-split"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    // Progressive enhancement hook (future reveal/IO; safe no-op for now)
    // This keeps footprint tiny and avoids layout jank.
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-sectionv2"] && !Shopify.designMode) return;
  try {
    
    (function(){
      var root = document.currentScript.closest('.tech');
      if(!root) return;

      // Reduced motion preference
      var reduce = false;
      try{ reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}

      // Overlay rotator
      var rotator = root.querySelector('[data-tech-rotator]');
      if(rotator){
        var auto = root.getAttribute('data-overlay-auto') !== 'false' && !reduce;
        var interval = parseInt(root.getAttribute('data-overlay-interval') || '4000', 10);
        var track = rotator.querySelector('.tech__overlay-track');
        var items = rotator.querySelectorAll('.tech__overlay-item');
        var i = 0, timer = null;

        function go(n){ i = (n + items.length) % items.length; if(track){ track.style.transform = 'translateX(' + (-100 * i) + '%)'; } }
        function start(){ if(auto){ stop(); timer = setInterval(function(){ go(i+1); }, interval); } }
        function stop(){ if(timer){ clearInterval(timer); timer = null; } }

        var prev = rotator.querySelector('[data-ov-prev]');
        var next = rotator.querySelector('[data-ov-next]');
        if(prev){ prev.addEventListener('click', function(){ stop(); go(i-1); publish('tech_overlay_nav', {dir:'prev', index:i}); }); }
        if(next){ next.addEventListener('click', function(){ stop(); go(i+1); publish('tech_overlay_nav', {dir:'next', index:i}); }); }

        rotator.addEventListener('mouseenter', stop);
        rotator.addEventListener('mouseleave', start);
        rotator.addEventListener('focusin', stop);
        rotator.addEventListener('focusout', start);

        try{
          var io = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){ if(entry.isIntersecting){ start(); } else { stop(); } });
          }, { threshold: [0, 0.4, 1] });
          io.observe(rotator);
        }catch(e){ start(); }

        go(0);
      }

      // Analytics hooks (lightweight)
      function publish(name, payload){
        var enabled = root.getAttribute('data-analytics') !== 'false';
        if(!enabled) return;
        try{
          if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){
            Shopify.analytics.publish(name, Object.assign({ sectionId: root.getAttribute('data-section-id') }, payload||{}));
          }
        }catch(e){}
      }

      root.addEventListener('click', function(ev){
        var link = ev.target.closest('[data-tech-cta]');
        if(link){ publish('tech_section_cta_click', { type: link.getAttribute('data-tech-cta') || 'cta', href: link.getAttribute('href') }); }
      });

      // Video play/pause on view (progressive enhancement)
      try{
        var video = root.querySelector('.tech__video');
        var autoAttr = video && video.hasAttribute('autoplay');
        if(video && autoAttr && !reduce){
          var vio = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if(entry.isIntersecting && entry.intersectionRatio > 0.5){
                var p = video.play(); if(p && p.catch){ p.catch(function(){}); }
              }else{ video.pause(); try{ video.currentTime = 0; }catch(e){} }
            });
          }, { threshold: [0, 0.5, 1] });
          vio.observe(video);
        }
      }catch(e){}
    })();
  
  } catch(e) { console.error(e); }
})();
})();
